/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ContentChild, EventEmitter, forwardRef, Input, Output, TemplateRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Utils } from '../utils/utils';


export interface MultiStateButtonChangeEvent {
    originalEvent: MouseEvent;
    value: any[];
    option: any;
    wasMax: boolean;
}

export const MULTISTATEBUTTON_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MultiStateButtonComponent),
    multi: true
};

@Component({
    selector: 'app-multi-state-button',
    templateUrl: './multi-state-button.component.html',
    providers: [MULTISTATEBUTTON_VALUE_ACCESSOR],
    changeDetection: ChangeDetectionStrategy.Default,
    styleUrls: ['./multi-state-button.component.scss']
})
export class MultiStateButtonComponent {

    @Input() options!: any[];

    @Input() optionLabel!: string;

    @Input() additionalOptionLabel!: string;

    @Input() optionValue!: string;

    @Input() optionDisabled!: string;

    @Input() tabindex = 0;

    @Input() maxSelections!: number;

    @Input() multiple!: boolean;

    @Input() style: any;

    @Input() styleClass!: string;

    @Input() ariaLabelledBy!: string;

    @Input() disabled!: boolean;

    @Input() dataKey!: string;

    @Output() optionClick = new EventEmitter<any>();

    @Output() changed = new EventEmitter<MultiStateButtonChangeEvent>();

    @ContentChild(TemplateRef) itemTemplate: any;

    value: any;

    onModelChange?: (v: any) => void;
    //onModelChange: Function = () => { };

    onModelTouched?: () => void;

    constructor(public cd: ChangeDetectorRef) { }

    getOptionLabel(option: any) {
        return this.optionLabel ? Utils.resolveFieldData(option, this.optionLabel) : (option.label != undefined ? option.label : option);
    }

    getAdditionalOptionLabel(option: any) {
        return this.additionalOptionLabel ? Utils.resolveFieldData(option, this.additionalOptionLabel): null;
    }

    getOptionValue(option: any) {
        return this.optionValue ? Utils.resolveFieldData(option, this.optionValue) : (this.optionLabel || option.value === undefined ? option : option.value);
    }

    isOptionDisabled(option: any) {
        return this.optionDisabled ? Utils.resolveFieldData(option, this.optionDisabled) : (option.disabled !== undefined ? option.disabled : false);
    }

    writeValue(value: any): void {
        this.value = value;
        this.cd.markForCheck();
    }

    registerOnChange(fn: (v: any)=> void): void {
        this.onModelChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onModelTouched = fn;
    }

    setDisabledState(val: boolean): void {
        this.disabled = val;
        this.cd.markForCheck();
    }

    onItemClick(event: MouseEvent, option: any, index: number) {
        if (this.disabled || this.isOptionDisabled(option)) {
            return;
        }

        if (this.multiple) {
            if (this.isSelected(option)) {
                this.removeOption(option);
            }
            else {
                if(this.value.length === this.maxSelections){
                    // Do Nothing;
                } else {
                    this.value = [...(this.value || []), this.getOptionValue(option)];
                }
            }
        }
        else {
            this.value = this.getOptionValue(option);
        }

        this.optionClick.emit({
            originalEvent: event,
            option: option,
            index: index
        });

        if (this.onModelChange) {
            this.onModelChange(this.value);
        }

        this.changed.emit({
            originalEvent: event,
            value: this.value,
            option,
            wasMax: this.value.length === this.maxSelections
        });
    }

    onBlur() {
        if (this.onModelTouched) {
            this.onModelTouched();
        }
    }

    removeOption(option: any): void {
        this.value = this.value.filter((val: any) => !Utils.equals(val, this.getOptionValue(option), this.dataKey));
    }

    isSelected(option: any) {
        let selected = false;
        const optionValue = this.getOptionValue(option);

        if (this.multiple) {
            if (this.value) {
                for (const val of this.value) {
                    if (Utils.equals(val, optionValue, this.dataKey)) {
                        selected = true;
                        break;
                    }
                }
            }
        }
        else {
            selected = Utils.equals(this.getOptionValue(option), this.value, this.dataKey);
        }

        return selected;
    }

}

